/* Native Shopify product forms remain responsible for pricing and basket behaviour. */
if (!window.ispStandardQuoteBound) {
  window.ispStandardQuoteBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-isp-standard-quote]');
    if (!link) return;
    const root = link.closest('product-info');
    const id = root?.querySelector('product-form input[name="id"]')?.value;
    const speed = root?.querySelector('[data-radar-speed]')?.value?.trim();
    const power = root?.querySelector('[data-radar-speed]') ? root.querySelector('variant-selects select')?.value : '';
    const quantity = root?.querySelector('input[name="quantity"]')?.value;
    const url = new URL(link.href);
    if (id) url.searchParams.set('variant_id', id);
    // Existing contact form reads source/product/variant_id; include quantity in the visible enquiry context.
    url.searchParams.set('source', 'Product enquiry' + (power ? ' — power supply ' + power : '') + (quantity ? ' — quantity ' + quantity : '') + (speed ? ' — requested speed limit ' + speed + ' mph' : ''));
    url.searchParams.set('product_url', location.href);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    url.hash = 'ContactForm';
    link.href = url.toString();
  });
}
